import React, { MouseEvent } from 'react';
import cn from 'clsx';
import { getImageSrc, Link } from 'common/components';
import { VariantAxisPoint, VariantAxisProduct, VariantsAxis } from 'modules/collections';
import { createElementKey } from 'utils';
import {
  activeAxisPoint,
  activeAxisPoints,
  axisPoint,
  axisPointPreview,
  inactiveAxisPoint,
} from './axis-points-styles';

type AxisPointProps = {
  activePoint: VariantAxisProduct;
  axisPoints: VariantAxisPoint[];
  axisMeta: VariantsAxis;
  landingName: string;
  onPointClick: (e: MouseEvent, point: VariantAxisPoint, axis: string) => void;
  onPointWheelClick: (e: MouseEvent, point: VariantAxisPoint, axis: string) => () => void;
};

export const AxisPointsB: React.FC<AxisPointProps> = ({
  activePoint, axisMeta, axisPoints, landingName, onPointClick, onPointWheelClick,
}) => (
  <div className={activeAxisPoints}>
    {axisPoints.map((point, pointIndex) => (
      <Link
        className={cn(axisPoint, {
          [activeAxisPoint]: activePoint.axesValues?.find(({ id }) => id === axisMeta.attribute)?.axis === point.label,
          [inactiveAxisPoint]: !point.available,
        })}
        href={point.productUrl}
        key={createElementKey('axis-point', pointIndex)}
        onClick={(e) => onPointClick(e, point, axisMeta.attribute)}
        onAuxClick={e => onPointWheelClick(e, point, axisMeta.attribute)}
        title={activePoint.displayedName}
      >
        <img
          alt={point.displayedName}
          className={axisPointPreview}
          height={48}
          src={getImageSrc(
            `${landingName}${point.axisMediaPhoto}`,
            {
              width: 48,
              height: 48,
              objectFit: 'fill',
            },
            true
          )}
          width={48}
        />
      </Link>
    ))}
  </div>
);
